var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "mobile" },
      [
        _c(
          "v-container",
          { attrs: { fluid: "" } },
          [
            _vm.foodCategories.length === 0
              ? _c(
                  "div",
                  [
                    _c("v-skeleton-loader", {
                      staticClass: "mx-auto maxw mt-2",
                      attrs: { type: "list-item" },
                    }),
                    _c("v-skeleton-loader", {
                      staticClass: "mx-auto maxw mt-2",
                      attrs: { type: "list-item" },
                    }),
                    _c("v-skeleton-loader", {
                      staticClass: "mx-auto maxw mt-2",
                      attrs: { type: "list-item" },
                    }),
                  ],
                  1
                )
              : _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  _vm._l(_vm.foodCategories, function (cat) {
                    return _c(
                      "v-flex",
                      { key: cat.id, attrs: { xs12: "", md6: "", lg4: "" } },
                      [
                        _c("CategoryCard", {
                          staticClass: "pointer",
                          attrs: { category: cat },
                          nativeOn: {
                            "&click": function ($event) {
                              return _vm.gotoCategory(cat)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  1
                ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "tablet" },
      [
        _c(
          "v-container",
          { attrs: { "grid-list-lg": "" } },
          [
            _vm.foodCategories.length === 0
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "d-flex" },
                    [
                      _c("v-skeleton-loader", {
                        staticClass: "mx-auto maxw",
                        attrs: { "max-width": "360", type: "card" },
                      }),
                      _c("v-skeleton-loader", {
                        staticClass: "mx-auto maxw",
                        attrs: { "max-width": "360", type: "card" },
                      }),
                      _c("v-skeleton-loader", {
                        staticClass: "mx-auto maxw",
                        attrs: { "max-width": "360", type: "card" },
                      }),
                    ],
                    1
                  ),
                ])
              : _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  _vm._l(_vm.foodCategories, function (cat) {
                    return _c(
                      "v-flex",
                      { key: cat.id, attrs: { xs12: "", md6: "", lg4: "" } },
                      [
                        _c("CategoryCard", {
                          staticClass: "pointer",
                          attrs: { category: cat },
                          nativeOn: {
                            "&click": function ($event) {
                              return _vm.gotoCategory(cat)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  1
                ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }